<template>
    <div class="journey-email-step-content-widget">
        <div class="widget-header">
            <h3>{{ steps[step].title }}</h3>
            <div class="svg-container widget-close-button" @click="closeWidget">
                <widget-close-svg />
            </div>
        </div>
        <div class="content-wrapper">
            <div v-if="step === 'create'" class="create-step">
                <journey-step-email-composer
                    ref="composer"
                    :journeyStepId="journeyStepId"
                    :clientId="clientId"
                    :agencyId="agencyId"
                    :startFromScratch="startFromScratch" />
            </div>
            <div v-else-if="step === 'saving'" class="saving-step">
                <loading-screen-svg />
            </div>
        </div>
        <div class="widget-footer">
            <div class="cancel-container">
                <app-button class="transparent-btn" @click="closeWidget">Cancel</app-button>
            </div>
            <div class="action-container">
                <app-button class="secondary-btn" :loading="steps[step].loading" @click="openEmailTestWidget">Send test email</app-button>
                <app-button @click="steps[step].action" :loading="steps[step].loading">
                    {{ steps[step].buttonText }}
                </app-button>
            </div>
        </div>
    </div>
</template>

<script>
const AppButton = () => import('@/components/common/app-button');
const WidgetCloseSvg = () => import('@/components/svg/quick-add/widget-close-svg');
const JourneyStepEmailComposer = () => import('@/components/one-to-one-email/journey-step-email-composer');
const LoadingScreenSvg = () => import('@/components/svg/loading-screen-svg');

import EventBus from '@/scripts/event-bus.js';
import { LogLevel } from "@/scripts/logger";

export default {
    name: 'journey-email-step-content-widget',

    props: ['options', 'widget'],

    components: {
        'app-button': AppButton,
        'widget-close-svg': WidgetCloseSvg,
        'journey-step-email-composer': JourneyStepEmailComposer,
        'loading-screen-svg': LoadingScreenSvg
    },

    data() {
        return {
            isInitializing: true,
            journeyStepId: null,
            startFromScratch: false,
            agencyId: null,
            clientId: null,
            step: null,
            steps: {
                create: {
                    title: 'Journey Email Content',
                    buttonText: 'Save',
                    action: this.saveAndGoBack,
                    loading: false
                },

                saving: {
                    title: 'Saving',
                    buttonText: 'Saving',
                    action: () => {},
                    loading: true
                }
            }
        }
    },

    computed: {
        
    },

    methods: {
        openEmailTestWidget(){
            this.saveContent()
                .then(() => {
                    EventBus.$emit('open-widget', {
                        name: 'email-test-widget',
                        journeyStepId: this.journeyStepId,
                    });
				})
				.finally(() => {
                    this.step = 'create';
				});
        },

        saveAndGoBack() {
			this.saveContent()
                .then(() => {
                    this.$helpers.showSuccessNotification('Content successfully saved.');
                    this.closeWidget();
                })
                .catch((error) => {
                    this.step = 'create';
                    this.$helpers.showFailNotification('Failed to save content.', { error });
                });
		},

        saveContent() {            
            var isValid = this.$refs.composer.isValid();

            if (isValid) {
                this.step = 'saving';                
                return this.$refs.composer.save();
            } 
            else {
                this.$helpers.showFailNotification('Add some content before saving.', { level: LogLevel.INFO });
            }
        },

        closeWidget() {
            EventBus.$emit('close-widget', this.widget);
        }
    },

    created() {
        this.journeyStepId = this.options.journeyStepId;
        this.startFromScratch = this.options.startFromScratch || false;
        this.agencyId = this.options.agencyId;
        this.clientId = this.options.clientId;

        this.step = 'create';
    },

    destroyed() {
        
    }
}
</script>

<style scoped>
.journey-email-step-content-widget .saving-step {
    text-align: center;
}

.journey-email-step-content-widget .content-wrapper {
    padding: 0;
}

.journey-email-step-content-widget .action-container {
    display: flex;
}

.journey-email-step-content-widget .action-container .btn {
    margin-left: 15px;
}

.journey-email-step-content-widget .cancel-container .btn.transparent-btn {
    background: transparent;
    color: #877D88;
}

.journey-email-step-content-widget .cancel-container .btn.transparent-btn:hover {
    background: #E1E0E5;
}

.journey-email-step-content-widget .action-container .btn.white-btn {
    background: #FFFFFF;
    color: #877D88;
    border: 2px solid #E9E9EF;
}

.journey-email-step-content-widget .action-container .secondary-btn {
    background: transparent;
    color: #877D88;
	border: 2px solid #877D88;
}

.journey-email-step-content-widget .action-container .secondary-btn:hover {
    background: #E1E0E5;
}
</style>
